
































































import debounce from "lodash/debounce";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  minLength,
  sameAs,
} from "vuelidate/lib/validators";

import { getFieldError } from "@/core/tools/forms/get_field_error";

import { STORE_KEY, store } from "./_store";
import Attachments from "@/components/Controls/Attachments.vue";

@Component({
  mixins: [validationMixin],
  computed: {
    ...mapState(STORE_KEY, ["loaded", "loading", "fatalError", "form"]),
    ...mapGetters(STORE_KEY, ["fields"]),
    ...mapState("ubic", ["token"]),
  },
})
export default class PrimeCostCopyForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    console.log("this.isNew", this.isNew);
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeValue`, { field, value });
  }

  saveFormData() {
    this.$store
      .dispatch(`${STORE_KEY}/saveForm`)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);

        this.$emit("form-close");
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: "is-warning",
          message: `При сохранении возникли проблемы. Попробуйте позже.`,
        });
      });
  }

  beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }
}
